import React from 'react';
import { Col, Row } from 'antd';
import { Texts } from '@luckycart/xpn-types/build/src/entities/reward-config.entity';

import { validatePhoneNumber, validateRequired, validateZipCode } from '../../utils/validateForm';
import { AccessibleInputField } from './AccessibleInputField';

interface Props {
  texts: Texts;
  missingMessage: string;
  invalidMessage: string;
}

export const PhysicalRewardForm: React.FunctionComponent<Props> = ({ texts, missingMessage, invalidMessage }) => {
  const {
    placeholders: {
      firstName: firstNamePlaceholder,
      lastName: lastNamePlaceholder,
      phone: phonePlaceholder,
      address: addressPlaceholder,
      additionalAddress,
      zipCode: zipCodePlaceholder,
      city: cityPlaceholder,
    },
    first,
    last,
    phone,
    phoneLegal,
    address,
    cp,
    city,
  } = texts;

  return (
    <>
      <AccessibleInputField
        name="firstName"
        label={first}
        required
        validate={(value) => validateRequired(value, missingMessage)}
        placeholder={firstNamePlaceholder}
        autoComplete="given-name"
      />
      <AccessibleInputField
        name="lastName"
        label={last}
        required
        validate={(value) => validateRequired(value, missingMessage)}
        placeholder={lastNamePlaceholder}
        autoComplete="family-name"
      />
      <AccessibleInputField
        name="phone"
        label={phone}
        required
        validate={(phoneNumber) => validatePhoneNumber(phoneNumber, missingMessage, invalidMessage)}
        tooltip={phoneLegal}
        placeholder={phonePlaceholder}
      />
      <AccessibleInputField
        name="address"
        label={address}
        required
        validate={(value) => validateRequired(value, missingMessage)}
        placeholder={addressPlaceholder}
      />
      <AccessibleInputField
        name="additionalAddress"
        label={address}
        placeholder={additionalAddress}
      />
      <Row>
        <Col span={8}>
          <AccessibleInputField
            name="zipCode"
            label={cp}
            required
            validate={(value) => validateZipCode(value, missingMessage, invalidMessage)}
            placeholder={zipCodePlaceholder}
          />
        </Col>
        <Col span={15} offset={1}>
          <AccessibleInputField
            name="city"
            label={city}
            required
            validate={(value) => validateRequired(value, missingMessage)}
            placeholder={cityPlaceholder}
          />
        </Col>
      </Row>
    </>
  );
};
